module.exports = __webpack_public_path__ + "static/media/american-sign-language-interpreting.0bf1fb8b.svg";